// Portal feature flags (GitLab feature flags of the wallbox-portal project)
export const FEATURE_FLAGS = {
  // Basic plan gets the Business management features (Locations, bulk actions, user groups, reports).
  // Turn on only after the backend flag backend-monetizationpod-basic-plan-feature-parity is on.
  BASIC_PLAN_FEATURE_PARITY: 'basic-plan-feature-parity',
  CHARGER_TRANSFER_ACCEPTANCE: 'charger-transfer-acceptance'
} as const
